import { toast, ToastPosition } from 'react-toastify';
import { nanoid } from '@reduxjs/toolkit';

export const getToastOptions = (position?: ToastPosition) => ({
  position: position || toast.POSITION.BOTTOM_CENTER,
  toastId: nanoid(),
  className: 'toast',
});
